import React, { useState, useEffect, useContext, useRef } from "react";
import Box from "@mui/material/Box";
import axios from "axios";
import "../../style.css";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { useSelector } from "react-redux";
import LinkIcon from '@mui/icons-material/Link';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { SetredirectValue } from "../../../../Store/PageredirectSlice";
import { Helmet } from 'react-helmet';
import { ToastContainer, toast } from 'react-toastify';
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Rightsidebar from "../../Rightsidebar/Rightsidebar";
import { Commonfun, datezonechange } from '../../Commonfun';
import { AppContext } from "../../../../Context/Context";
import { timezoneval } from '../../Commonfun';
import { timezonechange } from "../../Commonfun";
import { Utils } from "../../../../Utils/Utils";
import Freeaudit from "../../../../Utils/Freeaudit";
import Loader from "../../CommonLoader";
import CommonAlert from "../../../../Commonalert/commonalert";
import DatagridComp from "../../DatagridComp";
// import PdfandCsv from "../PdfandCsv";
import CommonBreadCrumb from "../../../../Commonalert/commonbreadcrumb";
import { Container, Grid, Tooltip } from '@mui/material';
import { customDropdownStyles } from "../../../../Commonalert/commonDropdown";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "react-select";
import { CommonErrorAlert } from "../../../../Commonalert/commonErrorAlert";
import UserActivityTracker from "../../../../hooks/userActivityTracker";

export default function GitAudit() {

  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [jobDate, setjobDate] = useState("");
  const [notifycount, setNotifycount] = useState("");
  const [topActionItemPlan, settopActionItemPlan] = useState({ status: true, error: "" });
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);

  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value
  const [autoheightval, SetAutoheightval] = useState(true)
  const [faqData, setfaqData] = useState("2")
  const [toggle, setToggle] = useState(false);
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);

  //filter
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedJobDate, setSelectedJobDate] = useState(null);
  const [prevSelectedJobDate, setPrevSelectedJobDate] = useState(null);
  const [jobDateOptions, setJobDateOptions] = useState([]);
  //run report
  const [isReportOpen, setIsReportOpen] = useState(false);
  const [successApiopen, setSuccessApiOpen] = useState(false);
  const [successApierrorMsg, setSucessApierrorMsg] = useState('');

  const navigate = useNavigate()

  const checkUserPlan = async () => {
    // const topActionItemP = await Utils("top_action_items", ApiToken);
    const topActionItemP = { status: true, error: "" };
    if (topActionItemP.status) {
      callUserdataApi();
      faqdatafun();
    }
    settopActionItemPlan(topActionItemP);
  };

  useEffect(() => {
    checkUserPlan();
    fetchFilterOptions();
  }, []);

  const fetchFilterOptions = async () => {
    try {
      const jobDOptions = await axios
        .get(
          `${process.env.REACT_APP_API_URL}domain/get_report_job_details/?user_domain_id=${esodata.domaindata.value.header_selected}&job_type=security_audit&audit_type=git_audit`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          },
        )
        .catch((error) => {
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 400 ||
            error?.response?.status == 500
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (
            error?.code == "ERR_NETWORK" ||
            error?.response?.status == 404
          ) {
            navigate("/errorpages");
          }
        });
      if (jobDOptions?.data) {
        if (jobDOptions.data.jobs) {
          var Sections = [];
          jobDOptions.data.jobs.forEach((element) => {
            Sections.push({ label: datezonechange(element.completed_at), value: element.id });
          });
          setJobDateOptions(Sections);
        }
      }
    } catch (err) { }
  };

  const columns = [
    {
      field: "title",
      headerName: "Title",
      description: 'The name of the rule that triggered the audit, typically representing the type of security issue detected.',
      minWidth: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true
    },
    {
      field: "description",
      headerName: "Description",
      description: 'A detailed description of the issue detected in the repository',
      minWidth: 320,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true
    },
    {
      field: "file_path",
      headerName: "File Path",
      description: ' The file location within the repository where the issue was found.',
      minWidth: 300,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (cardData) => {
        let baseUrl =
          cardData.row.file_path.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData.row.file_path.split("/").slice(3).join("/");
        return (
          <>
            <Tooltip title={cardData.row.file_path}>
              <div className="prefered_url_external02">
                <span
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <span className="">
                    {baseUrl}
                  </span>
                  <span
                    className=""
                    style={{
                      // color: "#044792",
                      wordWrap: "break-word",
                      wordBreak: "break-word",
                    }}
                  >
                    {remaining}
                  </span>
                </span>
              </div>
            </Tooltip>
          </>
        );
      },
    },
    {
      field: "issue",
      headerName: "Issue",
      description: ' A brief description of the detected issue, often showing the type of security risk',
      minWidth: 250,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (cardData) => {
        let baseUrl =
          cardData.row.issue.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData.row.issue.split("/").slice(3).join("/");
        return (
          <>
            <Tooltip title={cardData.row.issue}>
              <div className="prefered_url_external02">
                <span
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <span className="">
                    {baseUrl}
                  </span>
                  <span
                    className=""
                    style={{
                      // color: "#044792",
                      wordWrap: "break-word",
                      wordBreak: "break-word",
                    }}
                  >
                    {remaining}
                  </span>
                </span>
              </div>
            </Tooltip>
          </>
        );
      },
    },
    {
      field: "merge_link",
      headerName: "Merge Link",
      description: 'A URL that links to the specific merge request or commit where the issue was introduced.',
      minWidth: 250,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (cardData) => {
        let baseUrl =
          cardData.row.merge_link.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData.row.merge_link.split("/").slice(3).join("/");
        return (
          <>
            <Tooltip title={cardData.row.merge_link}>
              <div className="prefered_url_external02">
                <span
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <span className="">
                    {baseUrl}
                  </span>
                  <span
                    className=""
                    style={{
                      // color: "#044792",
                      wordWrap: "break-word",
                      wordBreak: "break-word",
                    }}
                  >
                    {remaining}
                  </span>
                </span>
              </div>
            </Tooltip>
          </>
        );
      },
    },
    {
      field: "merge_message",
      headerName: "Merge Message",
      description: 'The message associated with the commit or merge request.',
      minWidth: 250,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true
    },
    {
      field: "merged_date",
      headerName: "Merged Date",
      description: 'The date when the code was merged into the main branch.',
      minWidth: 150,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true
    },
    {
      field: "merged_by",
      headerName: "Merged By",
      description: 'The name of the individual who merged the code',
      minWidth: 150,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true
    },
    {
      field: "email",
      headerName: "Email",
      description: 'The email address of the individual who merged the code',
      minWidth: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (cardData) => {
        return (
          <>
            <span
              style={{
                // color: "#044792",
                wordWrap: "break-word",
                wordBreak: "break-word",
              }}>{cardData.row.email}</span>
          </>
        );
      },
    },

  ];

  const rows = cardData ?? [];


  const callUserdataApi = async (jobId = "") => {
    setLoading(true);
    setTableLoading(true);

    const datavalue = await axios.get(
      `${process.env.REACT_APP_API_URL}security_tools/git_audit/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobId}&formats=''&timezone=''`, {
      headers: {
        Authorization: `${ApiToken}`,
      },
    }
    ).catch((error) => {
      if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
        setapiOpen(true);
        if (error?.response?.data?.security_config) {
          const securityError = <div dangerouslySetInnerHTML={{ __html: error?.response?.data?.security_config }} />
          setapierrorMsg(securityError);
        } else {
          setapierrorMsg(error?.response?.data?.error)
        }
      }
      else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
        navigate('/errorpages')
      }
    });
    if (datavalue?.data.table_data && datavalue?.data?.table_data.length > 0) {
      const dataval = datavalue?.data?.table_data;
      setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"));
      SetAutoheightval(false)

      const newData = dataval.map((obj, index) => {
        return { ...obj, sid: index + 1 };
      });
      setCardData(newData);
    }
    else {
      SetAutoheightval(true)
      setCardData("");
    }

    setTableLoading(false);
    setLoading(false);
  };


  const pdfdown = async () => {

    setLoading(true);
    setIsDownloading(true);
    const jobId = selectedJobDate ? selectedJobDate : { label: '', value: '' };
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}security_tools/git_audit/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=pdf&timezone=${timezoneval()}&job_id=${jobId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("GitAudit", "pdf", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();


        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloading(false);


  }

  const csvdown = async () => {
    setLoading(true);
    setIsDownloadingcsv(true);
    const jobId = selectedJobDate ? selectedJobDate : { label: '', value: '' };
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}security_tools/git_audit/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=csv&timezone=${timezoneval()}&job_id=${jobId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });
      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'gitaudit.csv';

        link.click();


        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloadingcsv(false);

  }

  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1)
    }
    else {
      setfaqData(2)
    }
    setToggle((pre) => !pre);
  };

  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=73`

    try {
      const doaminsectiondatavalue = await axios.get(
        datavar,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
      }
    } catch (err) { }
  }

  const handleDownlodingCSV = () => {
    csvdown();
  }

  const handleDownlodingPDF = () => {
    pdfdown();
  }

  const apihandleClose = () => {
    setapiOpen(false);
  };

  const handleModelPopUp = () => {
    openModal();
  }

  function openModal() {
    setIsFilterOpen(true);
  }

  function closeModal() {
    setIsFilterOpen(false);
    setSelectedJobDate(prevSelectedJobDate);
  }

  const filterNow = () => {
    const jobId = selectedJobDate ? selectedJobDate : { label: '', value: '' };
    callUserdataApi(jobId);
    setPrevSelectedJobDate(jobId);
    setIsFilterOpen(false);
  }

  const handleReset = () => {
    setSelectedJobDate(null);
  }

  //Run report

  const closeRunReport = () => {
    setIsReportOpen(false);
  }

  const runReportNow = async () => {
    setLoading(true);

    const datavalue = await axios.get(
      `${process.env.REACT_APP_API_URL}security_tools/run_security_report/?user_domain_id=${esodata.domaindata.value.header_selected}&report_type=git_audit`, {
      headers: {
        Authorization: `${ApiToken}`,
      },
    }
    ).catch((error) => {
      if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error)
      }
      else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
        navigate('/errorpages')
      }
    });
    if (datavalue?.status === 200) {
      setSuccessApiOpen(true);
      setSucessApierrorMsg(datavalue?.data?.success);
    }

    setIsReportOpen(false);
    setLoading(false);
  };

  const successApiClose = () => {
    setSuccessApiOpen(false);
  }


  return (
    <div className={`over_all_container top_action_list ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>Git Audit</title>
      </Helmet>

      {loading === true ? <Loader /> : null}

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <div>
                <h1 className="dashboard_header">
                  Git Audit
                  <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Security Tools', activeColor: false },
                      { title: 'Git Audit', activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6}>
              <div className="time_zone">
                <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                <span className="timezone-val">{timezoneval()}</span>
              </div>
            </Grid>

            <Grid item xs={12} md={6}>
              <div className="drop_down_button" >
                <button
                  title="Security Audit Settings"
                  className="btn_dashboard"
                  onClick={() => navigate('/security-audit-settings')}
                >
                  Security Audit Settings
                </button>
                <button
                  title="Run Report"
                  className="btn_dashboard"
                  onClick={() => setIsReportOpen(true)}
                // onClick={() => {
                //   if (first.statusDomain) {
                //     setcheckD(first.statusDomain);
                //   } else {

                //     setfaqData(2);
                //     setToggle(false);
                //     SetRunReportPopShow(true);
                //   }
                // }}
                // disabled={!analysisSummaryPlan.status}
                >
                  Run Report Now
                </button>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                {topActionItemPlan.status ?
                  <DatagridComp className="datagrid_custom_scroll"
                    columns={columns}
                    rows={rows}
                    autoheightval={autoheightval}
                    datagridval={2}
                    columnFreezeWidth={[0]}
                    tableLoading={tableLoading}
                    handleModelPopUp={handleModelPopUp}
                    handleDownlodingCSV={handleDownlodingCSV}
                    handleDownlodingPDF={handleDownlodingPDF}
                    customFilter={true}
                    DownloadShowFile={true}
                    DownloadShowPDF={1}
                    DownloadShowCSV={2}
                  />
                  : <Freeaudit planStatus={topActionItemPlan} />
                }
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={6}>
              <div className="footer-left">
                <p className="footer-text">
                  All Rights Reserved Copyright © 2026 |
                  <a href="https://www.elitesiteoptimizer.ai/" target="_blank"> <span className="footer-brand"> Elite site Optimizer</span></a>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="footer-right">
                <p>{/* Add content if needed */}</p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <div className="cnt_audit_outer_wrap">
        <div >
          {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}

        </div>
        <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
      </div>

      <Dialog
        open={isFilterOpen}
        onClose={closeModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter job_date_filter over_all_accessibility"
      >
        <DialogTitle className="keyword-dialog-header ">
          {"Filter By"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div className="cnt_hdr_blw_wrap row">
              <div>
                <div >
                  <div>
                    <span className="select_filter_text">Completed Date</span>
                    <Select
                      value={selectedJobDate}
                      options={jobDateOptions}
                      placeholder="Select..."
                      labelField="completed_at"
                      valueField="id"
                      onChange={(values) => {
                        setSelectedJobDate(values);
                      }}
                      styles={customDropdownStyles()}
                      menuPortalTarget={document.body}
                    />
                  </div>
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <button
            className="form_submit_btn"
            onClick={filterNow}
            style={{ cursor: "pointer" }}
          >
            Submit
          </button>
          <button style={{ cursor: "pointer" }} onClick={closeModal}>
            close
          </button>
          <button
            className="form_submit_btn"
            style={{ cursor: "pointer" }}
            onClick={handleReset}
          >
            Reset
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isReportOpen}
        onClose={closeRunReport}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter job_date_filter over_all_accessibility"
      >
        <DialogTitle className="keyword-dialog-header ">
          {"Run Report"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div>
              Can we run the report for Git Audit ?
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <button
            className="form_submit_btn"
            onClick={runReportNow}
            style={{ cursor: "pointer" }}
          >
            Run
          </button>
          <button style={{ cursor: "pointer" }} onClick={closeRunReport}>
            Cancel
          </button>
        </DialogActions>
      </Dialog>

      <CommonErrorAlert
        data={{
          apiopen: apiopen,
          apiErrorMsg: apierrorMsg,
          isIconStyled: true
        }}
        closeAlert={apihandleClose} />

      <CommonErrorAlert
        data={{
          apiopen: successApiopen,
          apiErrorMsg: successApierrorMsg,
          isIconStyled: false
        }}
        closeAlert={successApiClose} />
      <UserActivityTracker pagename="Security Tools - Git Audit" />

    </div>
  );
}
